/// <reference types="google.maps" />
import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EnvironmentConfig } from '@clooper/core';
import { Loader } from '@googlemaps/js-api-loader';
import * as uuid from 'uuid';

@Component({
  selector: 'app-map',
  styleUrls: ['./maps.component.scss'],
  templateUrl: './maps.component.html'
})
export class MapsComponent implements OnInit {

  private loader: any;
  private map: google.maps.Map;
  private infoWindow: google.maps.InfoWindow;
  private geocoder: google.maps.Geocoder;
  private userLocation: google.maps.LatLngLiteral = { lat: 6.60456, lng: 3.3128818 };
  @Input() center: google.maps.LatLngLiteral;
  @Output() geocoded: EventEmitter<{ latlng: any, [x: string]: any }> = new EventEmitter();

  id = 'm' + uuid.v4();

  constructor(
    private config: EnvironmentConfig,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.loader = new Loader({
      apiKey: this.config.google_api_key as string,
      libraries: ['places'],
      version: 'weekly'
    });
  }

  ngOnInit() {
    this.loader.load().then(() => {
      this.map = new google.maps.Map(this.document.getElementById(this.id) as HTMLElement, {
        // center,
        zoom: 15,
      });
      this.infoWindow = new google.maps.InfoWindow();
      // this.getUserLocation()
      let center: google.maps.LatLngLiteral;
      const clooperMarker = {
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="59" height="60" viewBox="0 0 59 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 0.234375C8.95431 0.234375 0 9.18868 0 20.2344V32.941C0 43.9867 8.95429 52.941 20 52.941H25.0786L28.712 59.2344L32.3455 52.941H38.2133C49.259 52.941 58.2133 43.9867 58.2133 32.941V20.2344C58.2133 9.18868 49.259 0.234375 38.2133 0.234375H20Z" fill="#1D4146"/><path d="M40.8557 25.7435L38.0231 23.4467V19.879C38.0231 19.8057 37.9938 19.7353 37.9415 19.6834C37.8893 19.6316 37.8184 19.6024 37.7445 19.6024H36.8158C36.7419 19.6024 36.671 19.6316 36.6188 19.6834C36.5665 19.7353 36.5372 19.8057 36.5372 19.879V22.245L30.0451 16.9848C29.7796 16.7722 29.4487 16.6562 29.1076 16.6562C28.7664 16.6562 28.4356 16.7722 28.17 16.9848L17.3595 25.7435C17.2832 25.8052 17.2347 25.8944 17.2246 25.9915C17.2145 26.0886 17.2436 26.1858 17.3056 26.2616L17.7746 26.8336C17.8365 26.909 17.9259 26.957 18.0233 26.9673C18.1207 26.9776 18.2182 26.9492 18.2947 26.8885L20.192 25.3499V36.5506C20.192 36.7462 20.2703 36.9338 20.4096 37.0721C20.5489 37.2104 20.7379 37.2882 20.935 37.2882H26.8787C27.0757 37.2882 27.2647 37.2104 27.404 37.0721C27.5434 36.9338 27.6216 36.7462 27.6216 36.5506V30.6507L30.5935 30.6645V36.5682C30.5935 36.7638 30.6718 36.9513 30.8111 37.0897C30.9504 37.228 31.1394 37.3057 31.3365 37.3057L37.2802 37.2905C37.4772 37.2905 37.6662 37.2128 37.8055 37.0744C37.9448 36.9361 38.0231 36.7486 38.0231 36.553V25.3499L39.9205 26.8885C39.9969 26.9501 40.0949 26.9791 40.1928 26.9691C40.2908 26.9591 40.3807 26.9108 40.4429 26.835L40.9119 26.263C40.9426 26.2253 40.9656 26.1819 40.9794 26.1353C40.9932 26.0887 40.9977 26.0399 40.9924 25.9917C40.9872 25.9434 40.9724 25.8966 40.949 25.8541C40.9255 25.8115 40.8938 25.7739 40.8557 25.7435ZM36.5321 35.8191H36.5367L32.079 35.833V29.9251C32.0783 29.7301 32.0002 29.5432 31.8615 29.4051C31.7228 29.267 31.5348 29.1889 31.3383 29.1876L26.8805 29.1752C26.7828 29.1749 26.6859 29.1937 26.5955 29.2307C26.5051 29.2676 26.4229 29.3219 26.3537 29.3904C26.2844 29.4589 26.2295 29.5403 26.192 29.6299C26.1545 29.7196 26.1352 29.8156 26.1352 29.9127V35.8191H21.6779V24.1464L29.1076 18.1279L36.5372 24.1464L36.5321 35.8191Z" fill="white"/></svg>'),
        fillColor: '#51B496',
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
        anchor: new google.maps.Point(15, 30),
      }

      if (this.center) {
        center = this.center;
        const marker: google.maps.Marker = new google.maps.Marker({ map: this.map, position: center, icon: clooperMarker });
        this.map.setCenter(center);
      } else {
        this.map.setCenter(this.userLocation);
      }
      this.geocoder = new google.maps.Geocoder();
    });
  }


  geocode(address: string) {
    if (address !== '' && address !== undefined) {
      const map = this.map;
      this.geocoder.geocode({ address }, (results: any, status) => {
        if (status === 'OK') {
          const { geometry, address_components } = results[0];
          const latlng: google.maps.LatLng = geometry.location;
          map.setCenter(latlng);
          const marker: google.maps.Marker = new google.maps.Marker({ map, position: latlng });
          const components = address_components.slice(-4).map((l: any) => l.long_name);
          let [city,] = components;
          const [, locality, state, country] = components;
          if (city === state && city !== locality) {
            city = locality;
          }
          this.geocoded.emit({ latlng: latlng.toJSON(), city, state, country });
        } else {
          // console.log('Geocode was not successful for the following reason: ' + status);
        }
      });
    }
  }

  getUserLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          const marker: google.maps.Marker = new google.maps.Marker({ map: this.map, position: pos });
          this.userLocation = pos
        },
        () => {
          this.handleLocationError(true, this.infoWindow, this.map.getCenter());
        }
      );
    } else {
      this.handleLocationError(false, this.infoWindow, this.map.getCenter());
    }
  }

  handleLocationError(browserHasGeolocation: boolean, infoWindow: google.maps.InfoWindow, pos: google.maps.LatLng | undefined) {
    //Handle location error if nee
  }

}
